const IconConstants = {
  App: "mdi-cellphone",
  Android: "mdi-android",
  Ios: "mdi-apple-ios",
  Dashboard: "mdi-monitor-dashboard",
  Schedule: "mdi-calendar-cursor",
  Agency: "mdi-account-search",
  Company: "mdi-office-building-outline",
  Location: "mdi-office-building-marker-outline",
  Worker: "mdi-clipboard-account-outline",
  Contact: "mdi-contacts-outline",
  Job: "mdi-account-search-outline",
  Opportunity: "mdi-lightbulb-on-outline",
  OpportunitySource: "mdi-lightbulb-question-outline",
  OpportunityLostReason: "mdi-lightbulb-alert-outline",
  Booking: "mdi-calendar-multiselect",
  Shift: "mdi-calendar-today",
  Position: "mdi-account-question-outline",
  Skill: "mdi-account-details-outline",
  Qualification: "mdi-file-certificate-outline",
  Uniform: "mdi-account-tie-outline",
  Branch: "mdi-lan",
  Industry: "mdi-account-hard-hat",
  Note: "mdi-note-outline",
  NoteCategory: "mdi-note-text-outline",
  Desk: "mdi-desk",
  Settings: "mdi-cog-outline",
  UserProfile: "mdi-account-circle-outline",
  User: "mdi-account-circle-outline",
  Group: "mdi-account-group-outline",
  Timesheet: "mdi-calendar-clock",
  OtherAddress: "mdi-map-marker-outline",
  Details: "mdi-format-columns",
  Department: "mdi-lan",
  Reports: "mdi-finance",
  Invoice: "mdi-invoice-text-outline",
  Create: "mdi-plus",
  Edit: "mdi-pencil",
  Delete: "mdi-delete",
  SendEmail: "mdi-email-edit-outline",
  ArrowRight: "mdi-arrow-right-bold-outline",
  MapMarker: "mdi-map-marker",
  OpenInNewWindow: "mdi-open-in-new",
  Upload: "mdi-file-upload-outline",
  Download: "mdi-file-download-outline",
  Driver: "mdi-car",
  ShiftDriver: "mdi-bus-school",
  ShiftPassenger: "mdi-hail",
  ShiftOwnWayThere: "mdi-train-car",
  ShiftFrom: "mdi-arrow-left",
  ShiftTo: "mdi-arrow-right",
  ShiftRoundTrip: "mdi-arrow-left-right",
  Availability: "mdi-calendar-question",
  PublicData: "mdi-eye-check-outline",
  PrivateData: "mdi-eye-off-outline",
  Verified: "mdi-check-circle-outline",
  Unverified: "mdi-help-circle-outline",
  Tick: "mdi-check-outline",
  ThumbsUp: "mdi-thumb-up-outline",
  Warning: "mdi-alert",
  RateCard: "mdi-cash-multiple",
  Document: "mdi-file-document-outline",
  Cancel: "mdi-cancel",
  Week: "mdi-calendar-week",
  Form: "mdi-file-document-edit-outline",
  Question: "mdi-file-question-outline",
  Compliance: "mdi-shield-alert-outline",
  JourneyTemplate: "mdi-car-outline",
  WorkTypes: "mdi-text-search",
  GoogleMaps: "mdi-google-maps",
  TelephoneInterview: "mdi-phone-in-talk-outline",
  OnlineInterview: "mdi-laptop",
  InPersonInterview: "mdi-account-outline",
  Conversation: "mdi-message-outline",
  FaqCategory: "mdi-frequently-asked-questions",
  FaqArticle: "mdi-frequently-asked-questions",
  BusinessHours: "mdi-briefcase-clock",
  ConversationTopic: "mdi-message-settings-outline",
  Cellphone: "mdi-cellphone",
  Web: "mdi-web",
  Email: "mdi-email",
  Integration: "mdi-connection",
  Campaign: "mdi-email-multiple-outline",
  SpecOut: "mdi-account-arrow-right-outline",
  Send: "mdi-send",
  PhoneCall: "mdi-phone-incoming-outgoing-outline",
  Meeting: "mdi-account-multiple-outline",
  Search: "mdi-magnify",
  Manage: "mdi-wrench-clock",
  Robot: "mdi-robot-outline",
  Add: "mdi-plus",
  Check: "mdi-check",
  MoreVertical: "mdi-dots-vertical",
  Link: "mdi-link",
  Calendar: "mdi-calendar",
  Phone: "mdi-phone",
  Task: "mdi-checkbox-marked-outline",
  Activity: "mdi-clipboard-list-outline",
  EmailIncoming: "mdi-email-arrow-left-outline",
  EmailOutgoing: "mdi-email-arrow-right-outline",
  PhoneIncoming: "mdi-phone-incoming",
  PhoneOutgoing: "mdi-phone-outgoing",
  Reply: "mdi-reply",
  ReplyAll: "mdi-reply-all",
  Close: "mdi-close",
  AgencyRole: "mdi-shield-account-outline",
  ReportingPeriod: "mdi-calendar-range",
  Kpi: "mdi-target"

};
export default IconConstants;
